import React, { useState, useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import ExpenseDatePicker from './ExpenseDatePicker';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';
import { COLORS } from '../../../utils/Application_Constants';

const ExpensePayDate = (props) => {
    const { index, expense, mode, isPosted, isPendingSubmission, isViewOnly } = props;
    const { control, watch, errors, setValue } = useFormContext();
    const minDate = moment(new Date()).startOf('day');
    const maxDate = moment(new Date()).startOf('day').add(30, 'days');
    const billType = watch(`expenseEntries[${index}].billType`);
    const isClinicianDeduction = billType === 'ClinicianDeduction';
    const [required, setRequired] = useState({ required: true });
    const handleDateChange = (e) => {
        if (e && e.startOf('day')) {
            setValue(`expenseEntries[${index}].payDate`, e.startOf('day').format('YYYY-MM-DD'));
        } else {
            setValue(`expenseEntries[${index}].payDate`, e);
        }
    };
    useEffect(() => {
        setRequired({
            required:
                expense?.status !== ExpenseStatusValuesEnum.NonReimbursable &&
                expense?.status !== ExpenseStatusValuesEnum.Abandoned &&
                (mode !== 'cc' ||
                    (mode === 'cc' &&
                        isClinicianDeduction &&
                        expense?.status === ExpenseStatusValuesEnum.Approved)),
        });
    }, [expense?.status]);

    return (
        <Grid2 item size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].payDate`}
                defaultValue={expense.payDate || null}
                rules={
                    isPosted
                        ? {}
                        : {
                              required: required.required
                                  ? 'Pay Date is required. Please enter a valid date.'
                                  : false,
                              validate: {
                                  invalid: (value) =>
                                      !value || moment(value).isValid() || 'Invalid date',
                                  maxDate: (value) =>
                                      !value ||
                                      moment(value).isSameOrBefore(maxDate) ||
                                      'Max date reached',
                                  minDate: (value) =>
                                      !value ||
                                      moment(value).isSameOrAfter(minDate) ||
                                      'Min date reached',
                              },
                          }
                }
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        onChange={(e) => {
                            onChange(e);
                            handleDateChange(e);
                        }}
                        inputProps={{ disableUnderline: true }}
                        value={value ? moment(value) : null}
                        id={`pay-date${index}`}
                        label="Pay date"
                        {...required}
                        disabled={isViewOnly || (isPosted && isViewOnly) || isPendingSubmission}
                        minDate={minDate}
                        maxDate={maxDate}
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.payDate),
                            helperText: errors.expenseEntries?.[index]?.payDate?.message,
                        }}
                        parentSx={{
                            '& .MuiInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.payDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpensePayDate;
